// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"192":"pages-page-designer-test","211":"pages-wishlist","234":"pages-product-details","339":"pages-home","357":"pages-editorial","928":"pages-product-list"}[chunkId] || chunkId) + ".js";
};